var React = require('react');

function Ghost (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"0.153076","y":"0.152344","width":"9.81887","height":"3.4366","rx":"1.5","fill":"white","key":0}),React.createElement("rect",{"x":"13.4084","y":"0.152344","width":"3.4366","height":"3.4366","rx":"1.5","fill":"white","key":1}),React.createElement("rect",{"x":"9.97168","y":"13.4082","width":"6.87321","height":"3.4366","rx":"1.5","fill":"white","key":2}),React.createElement("rect",{"x":"0.152832","y":"13.4082","width":"6.87321","height":"3.4366","rx":"1.5","fill":"white","key":3}),React.createElement("rect",{"x":"0.152832","y":"6.53516","width":"16.6921","height":"3.4366","rx":"1.5","fill":"white","key":4})]);
}

Ghost.defaultProps = {"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none"};

module.exports = Ghost;

Ghost.default = Ghost;
